import { gql } from '@apollo/client'

export const CREATE_UNIPAL_CONFIG = gql`
    mutation createUnipalConfig($unipal_config: UnipalConfigInput!) {
        createUnipalConfig(unipal_config: $unipal_config) {
            code
            success
            unipal_config {
                unipal_item_id
                route_type
                item_type
                routes {
                    route_id
                    route_name {
                        en
                        ar
                    }
                    seat_types
                    included
                }
                trips {
                    trip_id
                    trip_name {
                        en
                        ar
                    }
                    route_id
                    time_slots
                    days_of_week
                    included
                }
                daypasses {
                    daypass_id
                    daypass_name {
                        en
                        ar
                    }
                    included
                }
                status_code
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                effective_from
                effective_to
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
            }
        }
    }
`

export const UPDATE_UNIPAL_CONFIG = gql`
    mutation updateUnipalConfig($unipal_item_id: NonEmptyString!, $unipal_config: UpdateUnipalConfigInput!) {
        updateUnipalConfig(unipal_item_id: $unipal_item_id, unipal_config: $unipal_config) {
            code
            success
            message
        }
    }
`

export const UPDATE_UNIPAL_CONFIG_STATUS = gql`
    mutation updateUnipalConfigStatus($unipal_item_id: NonEmptyString!, $status_code: UnipalConfigStatus!) {
        updateUnipalConfigStatus(unipal_item_id: $unipal_item_id, status_code: $status_code) {
            code
            success
            message
        }
    }
`
